import { useState } from "react";
import { toast } from "../hooks/use-toast";
import { createBooking } from "../api";

const EMPTY = { name: "", email: "", phone: "", message: "" };

export function useContactForm() {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);

  const updateField = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const validate = () => {
    if (!form.name || !form.email || !form.message) {
      toast({
        title: "Please fill in the required fields",
        description: "Name, email and message are required.",
      });
      return false;
    }
    return true;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSending(true);
    try {
      await createBooking({ ...form, service_type: "enquiry" });
      setForm(EMPTY);
      toast({
        title: "Message received",
        description: "Thanks for getting in touch — I'll reply as soon as possible.",
      });
    } catch (err) {
      toast({
        title: "Something went wrong",
        description: "Please try again or WhatsApp me directly.",
      });
    } finally {
      setSending(false);
    }
  };

  return { form, sending, updateField, submit };
}
